import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { FileText, Globe, Download, Eye } from 'lucide-react';
import { JURISDICTION_NAMES } from '../../lib/constants';
import { JURISDICTION_FLAGS, getScoreColor } from './adminUtils';

export const AssessmentsTab = ({ assessments, onView, onDownload }) => (
  <Card className="bg-slate-800/50 border-slate-700" data-testid="admin-assessments-tab">
    <CardContent className="p-6">
      <h3 className="text-white font-semibold mb-4 flex items-center gap-2">
        <FileText className="h-5 w-5 text-[#3B82F6]" />
        All Assessments ({assessments.length})
      </h3>
      <div className="space-y-3">
        {assessments.map((assessment) => (
          <div
            key={assessment.id}
            className="flex items-center justify-between p-4 bg-slate-700/30 rounded-lg hover:bg-slate-700/50 transition-colors"
          >
            <div
              className="flex items-center gap-4 flex-1 cursor-pointer"
              onClick={() => onView(assessment)}
            >
              <span className="text-2xl">{JURISDICTION_FLAGS[assessment.jurisdiction]}</span>
              <div>
                <div className="flex items-center gap-2">
                  <p className="text-white font-medium">{assessment.user?.company_name || 'Unknown'}</p>
                  {assessment.assessment_type === 'foreign' && (
                    <Globe className="h-3 w-3 text-slate-500" />
                  )}
                </div>
                <p className="text-slate-500 text-sm">
                  {JURISDICTION_NAMES[assessment.jurisdiction]} • {assessment.user?.email}
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              {assessment.status === 'completed' ? (
                <>
                  <Badge className={getScoreColor(assessment.scores?.overall?.level)}>
                    {assessment.scores?.overall?.percentage}%
                  </Badge>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      onDownload(
                        assessment.id,
                        assessment.user?.company_name,
                        assessment.jurisdiction,
                      );
                    }}
                    className="border-slate-600 text-slate-300 hover:bg-slate-700"
                  >
                    <Download className="h-4 w-4" />
                  </Button>
                </>
              ) : (
                <Badge className="bg-[#F59E0B]/10 text-[#F59E0B]">In Progress</Badge>
              )}
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onView(assessment)}
                className="text-slate-400 hover:text-white"
              >
                <Eye className="h-4 w-4" />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </CardContent>
  </Card>
);
